{
  "footer": {
    "copyright": "© 2026 Ef Es Academy Ltd. ⋅ <PrivacyPolicy>隐私政策</PrivacyPolicy>"
  },
  "nav": {
    "about-us": "关于我们",
    "contacts": "联系方式",
    "home": "首页",
    "services": "服务",
    "solutions": "解决方案"
  },
  "privacy-policy-url": "/legal/privacy-policy/latest-en",
  "sec1": {
    "button-employee-login": "员工登录",
    "button-manager-login": "企业登录",
    "open-in": "在 Safari 中",
    "title1": "食品安全的数字化转型",
    "title2": "无纸化 一机掌握"
  },
  "sec2": {
    "left": {
      "item1": "用于入境控制和控制卡的数字化平台",
      "item2": "食品安全在线培训",
      "item3": "电子文档存档",
      "item4": "开店咨询",
      "item5": "HACCP文档",
      "item6": "内部检查与审计",
      "title": "我们的解决方案"
    },
    "right": {
      "item1": "无纸化 —— 一机掌握",
      "item2": "按职位和级别组织的视频课程和测试 —— 简单高效",
      "item3": "自动提醒截止日期",
      "item4": "节省时间和资源",
      "item5": "轻松融入日常工作",
      "item6": "由有多年食品安全经验的顾问制作",
      "title": "优势"
    }
  },
  "sec3": {
    "service1": {
      "item1": "界面友好，大大缩短填写时间",
      "item10": "用于集中化管理填写的管理面板",
      "item2": "AI – 控制卡监控",
      "item3": "检测错误、缺失值和不真实数据",
      "item4": "智能数据分析以提升安全性",
      "item5": "报告和改进建议",
      "item6": "提高透明度和可追溯性",
      "item7": "设定填写截止日期",
      "item8": "快捷存取检查填好的控制卡",
      "item9": "已填写控制卡的可靠存档",
      "subtitle": "直接从智能手机轻松填写控制卡",
      "title": "电子控制卡"
    },
    "title": "服务"
  },
  "sec5": {
    "consulting": {
      "group1": {
        "item1": "客观评估和对场地状况的真实理解",
        "item2": "根据经过验证的清单现场检查",
        "item3": "拍摄材料和具体建议",
        "item4": "实际状况与系统记录的对比",
        "item5": "提供给业主/管理者的分析报告和建议",
        "title": "内部检查"
      },
      "group2": {
        "item1": "从第一天起的专业帮助",
        "item2": "首次注册准备",
        "item3": "检查技术项目和流程",
        "title": "开店咨询"
      },
      "group3": {
        "item1": "完整的文件系统，准备好实际应用",
        "item2": "HACCP计划的开发和实施",
        "item3": "更改时更新文档",
        "title": "文档和HACCP"
      },
      "link": "了解更多请访问<Link>fsconsulting.bg</Link>",
      "subtitle": "确保食品场所的顺利运营"
    },
    "organizer": {
      "item1": "员工对文档的控制访问",
      "item2": "设置提醒以更新即将过期的文档",
      "item3": "安全存储文档",
      "subtitle": "按机构的数字化所有重要文档的存档"
    },
    "service2": {
      "item1": "通过手机摄像头直接将文档添加到安全的云空间，而不会占用设备内存",
      "item2": "允许多个员工同时工作 - 员工、文员、会计、监管机构",
      "item3": "查看、分享或打印已创建的文档",
      "item4": "根据设定标准搜索和筛选文档",
      "subtitle": "节省处理伴随文档的时间和精力",
      "title": "入境控制"
    },
    "subtitle1": "咨询服务",
    "subtitle4": "组织器",
    "training": {
      "item1": "系统化和更新的内容——包括10个约20分钟的视频课程中的130多页材料",
      "item2": "符合世界高质量和教学效率的要求",
      "item3": "知识测试形式",
      "item4": "根据员工的需求和职位轻松组织培训",
      "item5": "通过平台日历计划刷新培训",
      "item7": "课程由<Cpd>The CPD认证服务</Cpd>认证——这是一个领先的国际持续专业发展（CPD）培训认证机构。",
      "subtitle": "用现代且引人注目的多媒体培训取代讲座形式",
      "subtitle1": "食品安全培训"
    }
  },
  "sec6": {
    "p1": "食品安全学院的使命明确——将食品安全作为一种实践，而不仅仅是文件。我们相信，优质和安全的食物是知识每天应用的结果——不仅是在检查期间，而是在每个工作日，由团队的每个成员实现。",
    "p2": "我们的产品和培训是为了将理论与职业厨房和监管实践的实际经验结合在一起。它们给人们信心，正确工作，让业务放心并具有可追溯性。",
    "p3": "我们知道，在一个经常妥协的环境中，真正的专业精神始于个人责任。因此，我们的团队创造了帮助企业建立安全文化的解决方案——基于知识、透明度和实际行动。",
    "p4": "食品安全学院——因为这很重要。",
    "title": "关于我们",
    "video": {
      "alt": "Food Safety Academy 参加电视节目《Na Kafe》的画面"
    }
  },
  "sec7": {
    "demo": "预约10分钟演示",
    "email": "电子邮箱：<Email/>",
    "phone": "电话：<Phone/>",
    "title": "联系我们"
  },
  "sec8": {
    "subtitle": "加入我们的团队",
    "text": "如果您想参与分发此平台，请发送主题为<strong>分发和传播</strong>的电子邮件至<Email/>与我们联系以获取更多信息",
    "title": "职业"
  },
  "subtitle": "食品安全数字平台",
  "title": "食品安全学院",
  "youtube": {
    "caption": "在 YouTube 上观看视频（在新标签页中打开）"
  }
}
